var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-form-wysiwyg"},[_c('textarea',{staticClass:"admin-form-wysiwyg__wrapper",attrs:{"id":_vm.id},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }